import { inject, Injectable } from '@angular/core';

import type { Observable } from 'rxjs';
import { map } from 'rxjs';

import { TellentHttpApiService } from '@core/tellent-http-legacy';
import type { SkillsIdeate, SkillsIdeateStartParams } from '@core/tellent-skills-types';
import { ORG_GUID } from '@core/tellent-types';

@Injectable({ providedIn: 'root' })
export class SkillsIdeateHttpClient {
  private readonly httpApi = inject(TellentHttpApiService);
  private readonly orgGuid = inject(ORG_GUID);

  public startIdeate({
    positionGuids,
    proficiencyTierNames,
    userPrompt,
  }: SkillsIdeateStartParams): Observable<SkillsIdeate> {
    return this.httpApi
      .post(
        `/positions/org/${this.orgGuid}/positions/skills-ideates`,
        null,
        {
          positionGuids,
          proficiencyTierNames,
          userPrompt,
        },
        { skipCompany: true },
      )
      .pipe(map(response => response.data));
  }

  public getIdeate(id: number): Observable<SkillsIdeate> {
    return this.httpApi
      .get(`/positions/org/${this.orgGuid}/positions/skills-ideates/${id}`, null, {
        skipCompany: true,
      })
      .pipe(map(response => response.data));
  }
}
